/**
 * PWA install identity, resolved at build time.
 *
 * The lab build (`npm run buildlab`, which sets VITE_APP_ENV=lab) produces a
 * distinct name and badged icons so the lab PWA can be installed alongside the
 * production PWA on the same device without being confused for it. Production
 * builds (`npm run build`) leave VITE_APP_ENV unset and get the real identity.
 *
 * Single source of truth for both the web manifest endpoint and the
 * environment-driven <head> tags in the root layout.
 *
 * Local `vite dev` (import.meta.env.DEV) is also treated as lab so the lab-only
 * UI shows up while developing. Any `vite build` (including prod) sets DEV=false,
 * so production builds are unaffected.
 */
const isLab = import.meta.env.VITE_APP_ENV === 'lab' || import.meta.env.DEV;

export const PWA = {
	isLab,
	/**
	 * Whether to actively *invite* installation — the bottom install banner and
	 * the "Add App to Home Screen" links in the footer and bottom nav. The app is
	 * always installable regardless (the manifest, icons, and /install page always
	 * ship); this flag only controls the public nudges.
	 *
	 * Kept on in lab so we can test the prompts, but off in prod until we're ready
	 * to unveil the install experience publicly. To launch, change this to `true`.
	 */
	inviteInstall: isLab,
	name: isLab ? 'STAAC Lab' : 'St. Thomas Armenian Church',
	shortName: isLab ? 'STAAC Lab' : 'St. Thomas',
	themeColor: isLab ? '#EA580C' : '#722F37',
	backgroundColor: '#F5F0E8',
	description: 'St. Thomas Armenian Apostolic Church — Tenafly, NJ',
	appleTouchIcon: isLab ? '/apple-touch-icon-lab.png' : '/apple-touch-icon.png',
	icons: [
		{
			src: isLab ? '/icon-lab-192.png' : '/icon-192.png',
			sizes: '192x192',
			type: 'image/png',
		},
		{
			src: isLab ? '/icon-lab-512.png' : '/icon-512.png',
			sizes: '512x512',
			type: 'image/png',
		},
		{
			src: isLab ? '/icon-lab-maskable-512.png' : '/icon-maskable-512.png',
			sizes: '512x512',
			type: 'image/png',
			purpose: 'maskable',
		},
	],
};
